export class URLS {
  // public static GET_MENU = 'https://gothkdubq7.execute-api.us-east-1.amazonaws.com/prod/menu';
  // public static GET_MENU_BY_PROFITCENTER = 'https://gothkdubq7.execute-api.us-east-1.amazonaws.com/prod/menuByProfitCenter';
  public static GET_OTP = 'https://upght365zf.execute-api.us-east-1.amazonaws.com/stage/send';
  // ?tenantId=859



  // public static GET_MENU = 'https://xneyoapci2.execute-api.us-east-1.amazonaws.com/prod/menu';
  public static GET_MENU = 'https://ecomflows3.zaravya.com/menu';

  public static GET_BYCELL_MENU = 'https://ecomflows3.zaravya.com/byCellmenu';

  // public static GET_MENU_BY_PROFITCENTER = 'https://xneyoapci2.execute-api.us-east-1.amazonaws.com/prod/menuByProfitCenter';
  public static GET_MENU_BY_PROFITCENTER = 'https://ecomflows3.zaravya.com/menuByProfitCenter';

  public static GET_WERA_MENU_BY_PROFITCENTER = 'https://1f18dc0bkc.execute-api.us-east-1.amazonaws.com/dev/getMenuOptions';
  public static GET_WERA_MARCHANT_REGISTRATION = 'https://api.werafoods.com/order/v1/merchant/register';
  public static UPLOAD_MENU = "https://api.werafoods.com/pos/v2/menu/fullmenu";
}
